export enum AlertSurgeCooldownEnum {
    HOURS_6 = 'HOURS_6',
    HOURS_24 = 'HOURS_24',
    DAYS_3 = 'DAYS_3',
    DAYS_7 = 'DAYS_7'
}
